import { BaseService } from './base.service';
import { api } from '../client/axiosClient';
import { CustomResponseEntity, PaginatedResponse } from '../types/common';
import {
  ReportDto,
  CreateReportDto,
  ReportFilters,
  TargetOrgDto,
} from '../types/dtos/report';

const BASE_PATH = '/api/v1/reports';

export class ReportService extends BaseService<
  ReportDto,
  CreateReportDto
> {
  constructor() {
    super(BASE_PATH);
  }

  findAllPaginated(
    filters?: ReportFilters
  ): Promise<CustomResponseEntity<PaginatedResponse<ReportDto>>> {
    return api.get(BASE_PATH, { params: filters });
  }

  findById(id: string): Promise<CustomResponseEntity<ReportDto>> {
    return api.get(`${BASE_PATH}/${id}`);
  }

  requestReport(data: CreateReportDto): Promise<CustomResponseEntity<ReportDto>> {
    return api.post(BASE_PATH, data);
  }

  getDownloadUrl(id: string): Promise<CustomResponseEntity<string>> {
    return api.get(`${BASE_PATH}/${id}/download`);
  }

  getTemplateContent(id: string): Promise<CustomResponseEntity<string>> {
    return api.get(`${BASE_PATH}/${id}/template-content`);
  }

  getTargetOrgs(id: string): Promise<CustomResponseEntity<TargetOrgDto[]>> {
    return api.get(`${BASE_PATH}/${id}/target-orgs`);
  }

  delete(id: string): Promise<CustomResponseEntity<void>> {
    return api.delete(`${BASE_PATH}/${id}`);
  }
}

export const reportService = new ReportService();
